// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__EVOZx","bigColWidth":"Table_bigColWidth__3MNf8","biggerColWidth":"Table_biggerColWidth__--a2M","row":"Table_row__3CGdj","col":"Table_col__vIP7E"};